import React from "react";
import { Button } from "reactstrap";
import {
    updateExchangeRates,
    fetchExchangeRates,
    calculateTotals,
    updateInvoiceWithExchangeRate,
} from "./currencyUtils";
import { generateInvoiceNumber } from "./versionHandler";

const SaveHandler = ({
    pb,
    title,
    customerInfo,
    selectedProducts,
    selectedNotes,
    selectedContacts,
    currentInvoice,
    isSaving,
    totals,
    setIsSaving,
    setRateUpdateStatus,
    setCurrentInvoice,
    onSaveSuccess,
    displayCurrency,
    displayTotal,
    dueDate,
    validUntil,
    invoiceDate,
}) => {
    const handleSave = async () => {
        if (isSaving) return;
        setIsSaving(true);
        console.log("SaveHandler - Initial Values:", {
            displayCurrency,
            displayTotal,
            selectedProducts,
            customerInfo,
            selectedContacts,
        });

        try {
            // Validation checks
            if (!title.trim()) throw new Error("Teklif başlığı gereklidir");
            if (!customerInfo?.id) throw new Error("Müşteri seçimi yapılmalıdır");
            if (!selectedProducts.length)
                throw new Error("En az bir ürün eklenmelidir");

            // Get current exchange rates
            await updateExchangeRates(pb);
            const currentRates = await fetchExchangeRates(pb);

            // Calculate totals directly from selectedProducts
            const manuallyCalculatedTotal = selectedProducts.reduce(
                (total, product) => {
                    return (
                        total + parseFloat(product.unitPrice) * parseInt(product.quantity)
                    );
                },
                0
            );

            console.log("SaveHandler - Calculated Values:", {
                manualTotal: manuallyCalculatedTotal,
                displayTotal,
                displayCurrency,
                totals,
            });

             // JSON dönüşümleri
        const parsedTotals = JSON.stringify(totals);
        const parsedTRY = Number(totals.TRY); // Kesinlikle number olduğundan emin olalım

        // Detaylı tip kontrolü
        console.log('Value checks before save:', {
            tryValue: parsedTRY,
            tryValueType: typeof parsedTRY,
            originalTryValue: totals.TRY,
            originalTryValueType: typeof totals.TRY
        });

        if (isNaN(parsedTRY)) {
            throw new Error('TRY değeri sayısal değere dönüştürülemedi');
        }

            // Prepare invoice data
            // SaveHandler.js içinde
            const invoiceData = {
                title: title.trim(),
                invoice_number: currentInvoice?.invoice_number || generateInvoiceNumber(),
                customer: customerInfo.id,
                selected_contacts: customerInfo.selectedContacts?.map((contact) => contact.id) || [],
                due_date: dueDate || null,
                valid_until: validUntil || null,
                invoice_date: invoiceDate || new Date().toISOString().split('T')[0],
                products: JSON.stringify(selectedProducts),
                notes: JSON.stringify(selectedNotes || []),
                currency: displayCurrency,
                total_amount: parsedTotals, // Number() kaldırıldı, JSON string olarak bırakıldı
                amount_try: parsedTRY, // amount_try sayı olarak gönderilmeli
                status: "Taslak",
                payment_status: "Beklemede",
                customer_additional_notes: customerInfo?.additionalNotes || "",
                show_customer_additional_notes: customerInfo?.showAdditionalNotes || false,
                version: currentInvoice?.version || 1,
                version_history: currentInvoice?.version_history || "[]",
                original_invoice: currentInvoice?.original_invoice || null,
                exchange_rate_bulletin_no: currentRates.bulletinNo,
                exchange_rate_date: currentRates.date,
                contacts_info: JSON.stringify(
                    customerInfo.selectedContacts?.map((contact) => ({
                        id: contact.id,
                        name: contact.name,
                        title: contact.title,
                        email: contact.email,
                        phone: contact.phone,
                    })) || []
                ),
            };

            // Ek doğrulama kontrolü
            console.log('Type checks:', {
                total_amount_type: typeof invoiceData.total_amount,
                amount_try_type: typeof invoiceData.amount_try,
                total_amount: invoiceData.total_amount,
                amount_try: invoiceData.amount_try
            });


            console.log("Final invoice data:", JSON.stringify(invoiceData, null, 2));
            const finalData = {
                ...invoiceData,
                amount_try: Number(invoiceData.amount_try) // Son bir kez daha number'a çevirelim
            };
            console.log('Final data type check:', {
                amount_try: finalData.amount_try,
                type: typeof finalData.amount_try,
                isNumber: !isNaN(finalData.amount_try)
            });
            // Update with exchange rate information
            const updatedInvoiceData = await updateInvoiceWithExchangeRate(
                pb,
                invoiceData
            );

            // Save to database
            const record = currentInvoice?.id
            ? await pb.collection("invoices").update(currentInvoice.id, finalData)
            : await pb.collection("invoices").create(finalData);

            setCurrentInvoice(record);
            setRateUpdateStatus({
                type: "success",
                message: "Teklif başarıyla kaydedildi",
            });

            if (onSaveSuccess) {
                onSaveSuccess(record);
            }

            return record;
        } catch (error) {
            console.error("Save Error:", error);
            setRateUpdateStatus({
                type: "error",
                message: error.message || "Kayıt sırasında hata oluştu",
            });
            throw error;
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Button
            type="button"
            color="primary"
            onClick={handleSave}
            disabled={isSaving}
        >
            {isSaving ? (
                <span>
                    <i className="mdi mdi-loading mdi-spin me-2"></i>
                    Kaydediliyor...
                </span>
            ) : (
                <span>
                    <i className="ri-save-line align-bottom me-1"></i>
                    Kaydet
                </span>
            )}
        </Button>
    );
};

export default SaveHandler;